<template>
  <div class="pa-4">
    <AppAccess class="mb-6" />
    <RecruiterPermissions v-if="group && group.roles && group.roles.includes('recruiter')" class="mb-6" />
    <WorkspacesPermissions class="mb-6" />
    <Restrictions />
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { useMainStore } from '@/store/index';

import WorkspacesPermissions from '../habilitations/WorkspacesPermissions.vue';
import Restrictions from '../habilitations/Restrictions.vue';
import AppAccess from '../habilitations/AppAccess.vue';
import RecruiterPermissions from '../habilitations/RecruiterPermissions.vue';

export default {
  components: {
    WorkspacesPermissions,
    Restrictions,
    AppAccess,
    RecruiterPermissions
  },
  setup () {
    const store = useMainStore();

    const group = computed(() => store.group);

    return { group };
  }
};
</script>
